import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MiniTable from '../../components/mini-table';
import { compareBooleans } from '../../util/boolean';
import { formatCep } from '../../util/cep';
import { formatCnpj } from '../../util/cnpj';
import { compareStrings } from '../../util/string';
import TableCellEllipsis from '../../components/table-cell-ellipsis';

export default function EmpresaUnidadesTable({
  dataSource,
  loading,
  miniTableRef,
  onClick,
  onSelectedIdsChange,
  selectedIds,
  title
}) {
  const { t } = useTranslation();

  const fireClick = empresa => typeof onClick === 'function' ? onClick(empresa) : undefined;

  const renderCell = text => <TableCellEllipsis text={text || ' '} />;

  const columns = [
    {
      title: t('Unidade'),
      dataIndex: 'apelido',
      key: 'apelido',
      width: 150,
      sorter: (a, b) => compareStrings(a.apelido, b.apelido),
      render: renderCell
    },
    {
      title: t('Tipo'),
      dataIndex: 'tipo',
      key: 'tipo',
      width: 120,
      sorter: (a, b) => compareStrings(a.tipo, b.tipo),
      render: text => <div style={{ minWidth: 80 }}>{text || ' '}</div>
    },
    {
      title: t('CNPJ'),
      dataIndex: 'cnpj',
      key: 'cnpj',
      width: 150,
      sorter: (a, b) => compareStrings(a.cnpj, b.cnpj),
      render: text => formatCnpj(text || ''),
    },
    {
      title: t('CNAE Primário'),
      dataIndex: 'cnaePrimario',
      key: 'cnaePrimario',
      width: 120,
      sorter: (a, b) => compareStrings(a.cnaePrimario, b.cnaePrimario),
      render: renderCell,
    },
    {
      title: t('CNAEs Secundários'),
      dataIndex: 'cnaesSecundarios',
      key: 'cnaesSecundarios',
      width: 200,
      sorter: (a, b) => compareStrings(a.cnaesSecundarios, b.cnaesSecundarios),
      render: renderCell,
    },
   {
  title: t('UF'),
  dataIndex: 'uf',
  key: 'uf',
  width: 80,     
  sorter: (a, b) => compareStrings(a.uf, b.uf),
  render: text => <div style={{ minWidth: 80 }}>{text || ' '}</div>
},
    {
      title: t('Cidade'),
      dataIndex: 'cidade',
      key: 'cidade',
      width: 150,
      sorter: (a, b) => compareStrings(a.cidade, b.cidade),
      render: renderCell,
    },
    {
      title: t('CEP'),
      dataIndex: 'cep',
      key: 'cep',
      width: 120,
      sorter: (a, b) => compareStrings(a.cep, b.cep),
      render: text => text ? formatCep(text) : ' ',
    },
    {
      title: t('Endereço'),
      dataIndex: 'endereco',
      key: 'endereco',
      width: 250,
      sorter: (a, b) => compareStrings(a.endereco, b.endereco),
      render: (text, record) => {
        const cidadeEstado = [record.cidade, record.uf].filter(Boolean).join('/');
        const cep = record.cep ? t('CEP') + ': ' + formatCep(record.cep) : null;
        const endereco = [record.endereco || ' ', cidadeEstado, cep].filter(Boolean).join(', ');
        return <TableCellEllipsis text={endereco} />;
      },
    },
    {
      title: t('Objeto Social'),
      dataIndex: 'objetoSocial',
      key: 'objetoSocial',
      width: 250,
      sorter: (a, b) => compareStrings(a.objetoSocial, b.objetoSocial),
      render: renderCell,
    },
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowClassName={record => record.ativa ? undefined : 'inactive'}
      scroll={{ y: 350 }}
    />
  );
}

EmpresaUnidadesTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
